// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__do586","projectSection":"Projects_projectSection__u1PR3"};